import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { takeUntil, auditTime, filter } from 'rxjs/operators';
import { Subject, combineLatest } from 'rxjs';
import { EngineProgressState } from '../../state/progress/engine.progress.state';
import { StoryState } from 'src/app/story/state/story.state';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';

@Component({
  selector: 'app-engine-progress',
  templateUrl: './engine-progress.component.html',
  styleUrls: ['./engine-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EngineProgressComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject();

  constructor(private store: Store, private changeDetectorRef: ChangeDetectorRef) {}

  storyLoadProgress = 0;

  ngOnInit() {
    const progress$ = this.store.select(EngineProgressState.getChunkLoadProgress);
    const chunk$ = this.store.select(StoryState.getLoadingChunk);

    combineLatest(progress$, chunk$)
      .pipe(
        filter(() => {
          const loadChunks = this.store.selectSnapshot(StoryState.getLoadChunks);
          return loadChunks !== null && loadChunks.length > 0;
        }),
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe(([progress, chunk]) => {
        const selectedChapterLoading =
          chunk !== null &&
          chunk.chapterId === this.store.selectSnapshot(StoryChaptersState.getSelectedChapterId);

        // Only update progress for current chapter
        this.storyLoadProgress = selectedChapterLoading ? progress : 1;
        this.changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
